
import { useEffect, useState } from "react";
import { useParams, useNavigate  } from 'react-router-dom';
import * as utils from "../utils/utils.js";
import Motus from './Motus.js'
import { useAuth } from "../context/AuthContext.js";
import { toast } from 'react-toastify';
import { ValidateContext } from '../context/ValidateContext.js';

function Game() {
  const mode = useParams().mode;
  const myUser = useAuth();
  const navigate = useNavigate ();

  // === STRUCTURE D'ÉTAT ===
  const [solution, setSolution] = useState("");
  const [wordAttempt, setWordAttempt] = useState("");
  const [wordLength, setWordLength] = useState(0);
  const [wordExist, setWordExist] = useState(0);

  // user Prefs
  const [difficulty, setDifficulty] = useState();
  const [showFirstLetter, setShowFirstLetter] = useState(1);
  const [mustStartWithFirstLetter, setMustStartWithFirstLetter] = useState(0);
  const [posFirstLetter, setPosFirstLetter] = useState(2);
  const [gameSounds, setGameSounds] = useState(0);

  const [newGame, setNewGame] = useState();
  const [gameId, setGameId] = useState(0);
  const [gameLevel, setGameLevel] = useState(1);

  const maxAttempts = 6;
  const [currentRow, setCurrentRow] = useState(0);
  const [letterPosition, setLetterPosition] = useState(1);

  const [keyboard, setKeyboard] = useState(localStorage.getItem('motus_keyboard_' + myUser.id) !== null ? JSON.parse(localStorage.getItem('motus_keyboard_' + myUser.id)) : {});

  const [grid, setGrid] = useState(localStorage.getItem('motus_grid_' + myUser.id) !== null ? JSON.parse(localStorage.getItem('motus_grid_' + myUser.id)) : []);

  const [statuses, setStatuses] = useState(JSON.parse(localStorage.getItem('motus_statuses_' + myUser.id)));
  const [validateState, setValidateState] = useState(localStorage.getItem('motus_validate_' + myUser.id) !== null ? JSON.parse(localStorage.getItem('motus_validate_' + myUser.id)) : false);

  // mémoire des positions confirmées (lettre ou null)
  const [confirmedCorrect, setConfirmedCorrect] = useState(JSON.parse(localStorage.getItem('motus_confirmed_' + myUser.id)));
  const [revealAnimationRow, setRevealAnimationRow] = useState(null);

  // Save current game in local storage to restore it when page reload ---------------
  // Update statuses in localStorage
  useEffect(() => {
    localStorage.setItem('motus_statuses_' + myUser.id, JSON.stringify(statuses))
  }, [statuses]);

  // Update grid in localStorage
  useEffect(() => {
    localStorage.setItem('motus_grid_' + myUser.id, JSON.stringify(grid))
  }, [grid]);

  // Update confirmedCorrect in localStorage
  useEffect(() => {
    localStorage.setItem('motus_confirmed_' + myUser.id, JSON.stringify(confirmedCorrect))
  }, [confirmedCorrect]);

  // Update keyboard in localStorage
  useEffect(() => {
    localStorage.setItem('motus_keyboard_' + myUser.id, JSON.stringify(keyboard))
  }, [keyboard]);

  // Update validate button state in localStorage
  useEffect(() => {
    if (letterPosition === solution.length +1) { 
      setValidateState(true);
    }
    else {
      setValidateState(false);
    }
    
    localStorage.setItem('motus_validate_' + myUser.id, letterPosition === solution.length +1)
  }, [letterPosition]);

  // get current row when resuming game
  const getCurrentPosition = (grid) => {
    for(let i=0; i<grid.length; i++) {
      for(let j=0; j<grid[i].length; j++) {
        if (grid[i][j] === '') {
          return {'row' : i, 'pos': j};
        }
      }
    }
    return 0
  }

  // 1. Load game status from DB when mode change --------------
  useEffect(() => {
    async function getUserScore(mode) {
      fetch(process.env.REACT_APP_API_SERVER + '/api/user/'+ myUser.id +'/mode/' + mode, {
        method: 'GET', 
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + myUser.token} 
      })
      .then(response => response.json())
      .then(data => setScore(data));
      return;
    }
    getUserScore(mode);
  }, [mode]);

  // Level is ready ----------------
  const setScore = (scoreData) => {
    if (scoreData.id !== 0) {
      setGameId(scoreData.id);
      setGameLevel(scoreData.level);
      return;
    }
    else {
      console.log("init score");
      initUserScore(mode);
      return;
    }
  }

  // insert new line in score DB
  async function initUserScore(mode) {
    fetch(process.env.REACT_APP_API_SERVER + '/api/user/'+ myUser.id +'/mode/' + mode, {
      method: 'POST', 
      headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + myUser.token} 
    })
    .then(response => response.json())
    .then(data => setGameId(data.id));
    return;
  }

  // Save score in DB -----
  async function saveScore(gameId, state) {  
    fetch(process.env.REACT_APP_API_SERVER + '/api/game/'+ gameId +'/state/' + state, {
        method: 'PUT', 
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + myUser.token} 
      })
    .then(response => response.json())
    .then(data => console.log(data));
    return;
  }

  // 2. Load user prefs once --------------
  useEffect(() => {
    async function getUserPrefs() {
      fetch(process.env.REACT_APP_API_SERVER + '/api/user/'+ myUser.id +'/prefs', {
        method: 'GET', 
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + myUser.token} 
      })
      .then(response => response.json())
      .then(data => checkPrefs(data));
      return;
    }
    getUserPrefs();
  }, []);

  // Set user prefs
  const checkPrefs = (prefs) => {
    if (prefs.difficulty !== 'not_found') {
      setDifficulty(prefs.difficulty);
      setShowFirstLetter(prefs.show_first_letter);
      setMustStartWithFirstLetter(prefs.must_start_with_letter);
      setPosFirstLetter(prefs.must_start_with_letter ? 2 : 1);
      setGameSounds(prefs.sounds);
    } else {
      toast.success("Vous devez d'abord préciser vos préférences de jeu", {
        autoClose: 2000,
        onClose: () => navigate('/prefs'),
      });
    }
  }

  // 3.Load word from DB --------------
  useEffect(() => {
    async function loadWordInDB(difficulty, mode) {
      let url = '/api/word/' + difficulty;
      if (mode === 'maxword') url = '/api/word/' + difficulty + '/user/' + myUser.id;
      
      fetch(process.env.REACT_APP_API_SERVER + url, {
        method: 'GET', 
        headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + myUser.token} 
      })
      .then(response => response.text())
      .then(word => setWordToPlay(word));
    }

    // Load Word from localStorage
    if (localStorage.getItem('motus_word_' + myUser.id)) {
      setSolution(window.atob(localStorage.getItem('motus_word_' + myUser.id)));
      loadGrid();
    }
    // Load Word from DB 
    else {
      if (difficulty === undefined) return;
      loadWordInDB(difficulty, mode);
    }
  }, [difficulty, newGame]);

  // Word from DB is ready to play ----------------
  const setWordToPlay = (word) => {
    
    if (word !== 'not_found') {
      setSolution(word);
      localStorage.setItem('motus_word_' + myUser.id, window.btoa(word));

      // Générer la grille une fois la longueur connue
      initGrid(word);
    }
    else {
      toast.error('Erreur, veuillez actualiser la page', {
        autoClose: 2000
      });
    }
  }

  // Init Grid ------------------
  const initGrid = (solution) => {
    const emptyRow = Array(solution.length).fill("");
    const newGrid = Array.from({ length: maxAttempts }, () => [...emptyRow]);
    const newStatuses = Array.from({ length: maxAttempts }, () => Array(solution.length).fill(""));
    
    setGrid(newGrid);
    setStatuses(newStatuses);
    setCurrentRow(0);
    setKeyboard({});
    setLetterPosition(1);
    setConfirmedCorrect(Array(solution.length).fill(null));

    // Pref : First Letter engaged
    if (showFirstLetter) {
      // Maj statuses
      const newConfirmed = Array(solution.length).fill(null);
      newConfirmed[0] = solution[0].toLowerCase();
      setConfirmedCorrect(newConfirmed);

      // Display first letter
      const emptyRow = Array(solution.length).fill("");
      majGrid(Array.from({ length: maxAttempts }, () => [...emptyRow]), 0, solution[0], 0);

      // First letter green
      newStatuses[0][0] = 'correct';
      setStatuses(newStatuses);

      setLetterPosition(2);
    }
  }

  // Init Grid ------------------
  const loadGrid = () => {
    const newStatuses = [...statuses];
    
    let currentPositionSaved = getCurrentPosition(grid);
    setCurrentRow(currentPositionSaved.row);
    setLetterPosition(1); //default

    // Pref : First Letter engaged
    if (showFirstLetter) {
      // First letter green
      newStatuses[currentPositionSaved.row][0] = 'correct';
      setStatuses(newStatuses);
      setLetterPosition(2);
    }

    // get first position free
    setLetterPosition(currentPositionSaved.pos +1);
  }
  
  // Maj Grid : preset / delete / add char
  const majGrid = (grid, currentRow, char, pos) => {
    const newGrid = grid;
    const row = [...newGrid[currentRow]];
    const letterIndex = pos;
    row[letterIndex] = char.toLowerCase();
    newGrid[currentRow] = row;
    setGrid(newGrid);
  }

  // ON KEY PRESS -----------------------
  const handleKeyPress = (k) => {
    // Supprimer une lettre
    if (k === "←") {

      if (letterPosition > posFirstLetter) {
        // Maj letter position
        setLetterPosition(p => p -1);

        // Delete letter + Maj Grid
        const letterIndex = letterPosition -2;
        majGrid([...grid], currentRow, '', letterIndex);

        // supprimer le statut de cette case (enlever vert si présent sur cette ligne)
        const newStatuses = statuses.map(s => [...s]);
        newStatuses[currentRow][letterIndex] = "";
        setStatuses(newStatuses);
      }
    }

    // Saisie lettre
    if (/^[A-Z]$/.test(k)) {
      if (letterPosition <= solution.length) {
        const newGrid = [...grid];
        const row = [...newGrid[currentRow]];
        const oldLetter = row[letterPosition -1];
        const letterIndex = letterPosition -1;

        // Add letter & Maj Grid
        majGrid([...grid], currentRow, k, letterIndex);

        // enlever vert si lettre différente
        if (oldLetter !== k.toLowerCase()) {
          const newStatuses = statuses.map(s => [...s]);
          newStatuses[currentRow][letterIndex] = "";
          setStatuses(newStatuses);
        }

        // Maj de la position de la lettre
        setLetterPosition(p => p + 1);
      }
      return;
    }

    // Valider la ligne
    if (k === "Valider") {
      const attempt = grid[currentRow].join("");

      if (attempt.length !== solution.length) return;
      setWordAttempt(attempt);

      return;
    }
  };

  // Check Attempt --------------------
  const checkAttempt = () => {

    // check solution
    const result = utils.checkWord(solution, wordAttempt);

    // 1) Mettre à jour le statut de la ligne en cours (affiche couleurs)
    const newStatuses = statuses.map(s => [...s]);
    newStatuses[currentRow] = result;
    setStatuses(newStatuses);

    // 2) Mettre à jour le clavier
    const newKeyboard = { ...keyboard };
    result.forEach((s, i) => {
      const letter = wordAttempt[i].toUpperCase();
      if (newKeyboard[letter] !== "correct") {
        newKeyboard[letter] = s;
      }
    });
    setKeyboard(newKeyboard);

    // 3) Mettre à jour confirmedCorrect (persistant pour pré-remplissage futur)
    const newConfirmed = [...confirmedCorrect];
    for (let i = 0; i < solution.length; i++) {
      if (result[i] === "correct") {
        newConfirmed[i] = solution[i]; // on garde la lettre confirmée
      }
    }
    setConfirmedCorrect(newConfirmed);

    // 4) Pré-remplir la ligne suivante d'après confirmedCorrect (si existante)
    if (currentRow + 1 < maxAttempts) {
      const nextRow = currentRow + 1;
      const nextGrid = grid.map(r => [...r]);
      const nextStatuses = newStatuses.map(s => [...s]); // copie des statuses

      // Remplir chaque position confirmée
      const filledRow = Array(solution.length).fill("");
      for (let i = 0; i < solution.length; i++) {
        if (newConfirmed[i]) {
          filledRow[i] = newConfirmed[i];
          nextStatuses[nextRow][i] = "correct"; // on affiche vert sur la ligne suivante
        }
      }

      // Maj grid et status
      nextGrid[nextRow] = filledRow;
      setGrid(nextGrid);
      setStatuses(nextStatuses);
    }
    
    // Fin du jeu : Vérifier la victoire
    if (wordAttempt === solution) {
      toast.success("Vous avez trouvé le mot '" + solution.toUpperCase() + "', bravo!", {
        autoClose: 2000,
        onClose: () => {
          // Save score
          utils.clearStorage(myUser.id);
          saveScore(gameId, 'success');
          setGameLevel(gameLevel +1);
          setNewGame(gameLevel +1);
        }
      });
      return;
    }
    else {
      if (currentRow + 1 === maxAttempts) {
        toast.error("Vous n'avez pas trouvé le mot '" + solution.toUpperCase() + "', retentez votre chance", {
          autoClose: 2000,
          onClose: () => {
            // Save score
            utils.clearStorage();
            saveScore(gameId, 'fail');
            navigate('/');
          }
        });
        return;
      }
    }

    // Passe à la ligne suivante
    setCurrentRow(r => r + 1);

    // Get first free position to type
    for (let i = 0; i < newConfirmed.length; i++) {  
      if (newConfirmed[i] == undefined) {
        setLetterPosition(i +1);
        break;
      } 
    }
  }

  //Check word from DB ALL --------------
  useEffect(() => {
    async function checkDB(callback) {
      if (wordAttempt !== '') {
        fetch(process.env.REACT_APP_API_SERVER + '/api/word/exists/'+ wordAttempt, {
          method: 'GET', 
          headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + myUser.token} 
        })
        .then(response => response.json())
        .then(data => validateWord(data, callback));
      }
      return;
    }

    // Check Word
    checkDB(checkAttempt);
  }, [wordAttempt]); // Check word only when exists

  // Word exists ----------------
  const validateWord = (data, callback) => {
    if (data.status == 'success') {
      setWordExist(true);
      callback();
    }
    else {
      toast.error('Ce mot est introuvable dans notre dictionnaire désolé.', {
        autoClose: 2000,
      });
    }
  }

  return (
    <ValidateContext value={validateState}>
      <div>Niveau #{gameLevel} - Longueur : {solution.length} 
        {/*- Game ID #{gameId} (user #{myUser.id}) */}
      </div>
      <Motus
        grid={grid} 
        keyboard={keyboard} 
        handleKeyPress={handleKeyPress} 
        solution={solution} 
        statuses={statuses} 
        currentRow={currentRow} 
        letterPosition={letterPosition} 
        revealAnimationRow={revealAnimationRow} 
      />
    </ValidateContext>
  );
}

export default Game;